/* eslint-disable react/no-danger */
import { breederLevelSelectionOptions } from '@application/utils';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { InputField, InputLabel, InputSelectField } from '@presentation/components';
import { useFormikContext } from 'formik';
import type { MtBreederOnboardingFormValues, MtBreederOnboardingPageProps } from '../types';
import * as Styled from '../styled';

export const Step2: FC<
  Pick<
    MtBreederOnboardingPageProps,
    | 'agreementNumberWarning'
    | 'agreementNumberIsRequired'
    | 'hideAgreementNumberField'
    | 'breederTypeWarning'
  >
> = (props) => {
  const {
    agreementNumberIsRequired,
    agreementNumberWarning,
    breederTypeWarning,
    hideAgreementNumberField,
  } = props;
  const { translate } = useTranslation();
  const { values } = useFormikContext<MtBreederOnboardingFormValues>();

  return (
    <>
      <Styled.OnboardingInputWrapper>
        {breederTypeWarning ? (
          <Styled.BlueInfoBox full>
            <div dangerouslySetInnerHTML={{ __html: breederTypeWarning }} />
          </Styled.BlueInfoBox>
        ) : null}
        <InputLabel requiredColor="red" required>
          {translate('common.inputs.breederType.label')}
        </InputLabel>

        <InputSelectField
          noEmpty
          name="level"
          options={breederLevelSelectionOptions(translate, values.country)}
          variant="new"
          hasDropdownIcon
        />
      </Styled.OnboardingInputWrapper>

      {!hideAgreementNumberField ? (
        <Styled.OnboardingInputWrapper>
          <InputLabel required={agreementNumberIsRequired}>
            {translate(`common.inputs.agreementNumber.label.${values.country}`)}
          </InputLabel>
          {agreementNumberWarning ? (
            <Styled.BlueInfoBox full>{agreementNumberWarning}</Styled.BlueInfoBox>
          ) : null}
          <InputField name="agreementNumber" />
        </Styled.OnboardingInputWrapper>
      ) : null}
    </>
  );
};
